module.exports = __webpack_public_path__ + "static/img/3.940fbd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/3.png
// module id = PXJ8
// module chunks = 0